import { useEffect } from 'react'
import { batch, useDispatch, useSelector } from 'react-redux'
import CategoriesSwitcher from '../../components/CategoriesSwitcher'
import DiscoverButton from '../../components/DiscoverButton/DiscoverButton'
import Inspirations from '../../components/Feed'
import MobileAppPopup from '../../components/MobileAppPopup'
import SignUpCta from '../../components/SignUpCtaCommunity'
import UsernameUpdate from '../../components/username/UsernameUpdate'
import { COMMUNITY_CATEGORIES_LIST } from '../../constants/CommunityCategoriesConstants'
import { getFollowList } from '../../redux/actions/FollowingActions'
import { loadSavedUserInspirationIds } from '../../redux/actions/SaveInspirationAction'
import { setSelectedCommunityCategory } from '../../redux/communityReducers/DMReducer'
import { FeaturedCategories, FeaturedWrapper } from './Featured.styles'

export const FeaturedPage = () => {
  const dispatch = useDispatch()
  const { isAuthenticated } = useSelector(state => state.auth)
  const selectedCategory = useSelector(state => state.dm.selectedCategory)

  useEffect(() => {
    batch(() => {
      dispatch(loadSavedUserInspirationIds())
      dispatch(getFollowList())
    })
  }, [dispatch])

  const onChange = category => {
    dispatch(setSelectedCommunityCategory(category))
  }

  return (
    <>
      <FeaturedWrapper>
        <Inspirations
          paddingStart={isAuthenticated ? 80 : 250}
          paddingBottom={isAuthenticated ? 115 : 62}
          header={
            <FeaturedCategories isShowingCta={!isAuthenticated}>
              <div>{!isAuthenticated && <SignUpCta title="Join Our Community and Use Our App for Interior Design Inspiration" />}</div>
              <CategoriesSwitcher list={COMMUNITY_CATEGORIES_LIST} onChange={onChange} selected={selectedCategory} />
            </FeaturedCategories>
          }
          title=""
          filters={selectedCategory.filters}
          version="v4"
        />
        <UsernameUpdate />
      </FeaturedWrapper>
      <MobileAppPopup />
      <DiscoverButton />
    </>
  )
}
